import React from 'react';
import { QuestionAnswer } from '@material-ui/icons';
import LooksOneIcon from '@material-ui/icons/LooksOne';
import SubjectIcon from '@material-ui/icons/Subject';
import RadioButtonCheckedIcon from '@material-ui/icons/RadioButtonChecked';
import ListIcon from '@material-ui/icons/List';
import { IQuestionType } from 'pages/formsCreate/types';

type Props = {
  type: IQuestionType;
};

export const QuestionTypeIcon = ({ type }: Props) => {
  if (type === 'TEXT') return <SubjectIcon />;

  if (type === 'NUMERIC') return <LooksOneIcon />;

  if (type === 'UNIQUE_SELECT') return <RadioButtonCheckedIcon />;

  if (type === 'MULTIPLE_SELECT') return <ListIcon />;

  return <QuestionAnswer />;
};
